// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class BannerSectionRecord extends Immutable.Record({
  domain: String()
}) {
  // No methods
}

BannerSectionRecord.reviver = keyedReviver(BannerSectionRecord, {

})

module.exports = BannerSectionRecord
